import React from 'react';
import { Box } from '@mui/material';
import StorefrontConfigProvider from '../StorefrontConfigProvider';
import StorefrontHeader from './StorefrontHeader';
import StorefrontFooter from './StorefrontFooter';
import ShopTheme from '../shopTheme';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// `themed` applies the shop design system (shopTheme.js) to the page body.
// The storefront home stays unthemed; every other shop page opts in.
const StorefrontLayout = ({ children, themed = false }) => {
  const content = themed ? <ShopTheme>{children}</ShopTheme> : children;
  return (
    <StorefrontConfigProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <StorefrontHeader />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: themed ? '#fff' : undefined }}>
          {content}
        </Box>
        <StorefrontFooter />

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Box>
    </StorefrontConfigProvider>
  );
};

// See ModernMainLayout — lets RouteGate (RBAC Phase 3) render a refusal inside
// the storefront chrome instead of on a bare page.
StorefrontLayout.isAppLayout = true;

export default StorefrontLayout;
